export default "assets/images/logo-652dab96.svg";